import {IconConfig} from "./icon.model";

export const iconsWidgets: IconConfig[] = [
  {
    name: 'chat',
    path: 'assets/img/mat-icons/widgets/chat.svg',
  },
];
